import { Tooltip } from "react-tooltip"
import { getByLocalization, getByLocalizationRows, localize } from "../../../common/services/localization"
import { UpdateChangeType } from "../../../api/repositories/stats/models/updates"

export const Places: React.FC<{
    className?: string
    placeClassName?: string
    places: { [k: string]: number }
}> = ({ places, placeClassName, className }) => {
    const colors: { [k: string | number]: string } = {
        "1": "bg-1-place",
        "2": "bg-2-place",
        "3": "bg-3-place",
        "4": "bg-4-place",
        "5": "bg-5-place",
        "6": "bg-6-place",
    }

    return (
        <div className={`flex flex-col items-center ${className || ''}`}>
            <div className="flex flex-row">
                {Object
                    .keys(colors)
                    .map((k, i) => <Place className={placeClassName} key={i} place={k} color={colors[k]} rate={places[k] || 0} />)
                }
            </div>
        </div>
    )
}

export const LocalizeUpdateChange: React.FC<{
    changeType: UpdateChangeType
    className?: string
}> = ({ changeType, className }) => {
    return (
        <span className={`text-[16px] lg:text-[22px] font-['Reaver'] text-update-change-${changeType} ${className || ''}`}>
            {localize(changeType)}
        </span>
    )
}

export const LocalizeListElement: React.FC<{
    ruRows: string[]
    engRows: string[]
    className?: string
}> = ({ ruRows, engRows, className }) => {
    return (
        <ul className={`${className ?? ''} list-disc pl-5`}>
            {getByLocalizationRows(ruRows, engRows).map((r, i) => <li key={i}>{r}</li>)}
        </ul>
    );
}

export const LocalizeInnerHtml: React.FC<{
    ruRows?: string
    engRows?: string
    className?: string
}> = ({ ruRows, engRows, className }) => {
    const value = getByLocalization(ruRows, engRows)?.replace(/\r?\n/g, '<br/><div style="margin-bottom: 4px;"></div>');

    return (
        value
            ? <div className={className || ''} dangerouslySetInnerHTML={{ __html: value }} />
            : null
    );
};



export const DarkTooltip: React.FC<{
    id: string;
    className?: string;
    content?: React.ReactNode;
}> = ({ id, className, content }) => {
    return (
        <Tooltip
            id={id}
            className={`z-10 w-fit max-w-[30rem] bg-dark text-white font-['Roboto'] ${className || ''}`}
            render={() => content}
        />
    );
};

export const Place: React.FC<{
    place: string
    rate: number
    color: string
    value?: string | number
    className?: string
}> = ({ place, rate, color, value, className }) => {

    return <div className={`w-[12px] h-[24px] sm:w-[18px] sm:h-[55px] ${className || ''}`}>
        <div className={`flex-1 w-[90%] h-[24px] sm:h-[55px] flex flex-col ${className || ''}`}>
            <div className="flex-1" />
            <div style={{ height: `${rate * 100}%` }} className={`
				w-full
				bg-gradient-to-t
				${color}
				bottom-0
			` } />
        </div>
        <div className="text-10 font-['Roboto'] font-normal text-center mt-1">
            {place}
        </div>
    </div>
}